import { FormattedMessage } from "react-intl";

import { Button } from "@ps-design-system/components/Button";
import { StatusPill } from "@ps-design-system/components/StatusPill";
import { Text } from "@ps-design-system/components/Text";

import { trackReferVendorButtonClicked } from "../app-host-hub/analytics/host-hub-analytics";

const NoVendorsPanel = () => {
  const handleReferClick = () => {
    trackReferVendorButtonClicked({
      buttonName: "refer a vendor",
      buttonLocation: "my listings host",
    });
  };
  return (
    <div className="md:tw-py-40 md:tw-px-32 md:tw-mt-16 md:tw-border md:tw-border-gray-300 md:tw-rounded-4 md:tw-flex md:tw-items-center md:tw-gap-16">
      <div className="md:tw-w-[50%]">
        <div className="tw-mb-12">
          <StatusPill
            size="md"
            className="tw-border tw-box-border tw-border-purple-800 tw-bg-purple-200 tw-text-purple-800"
          >
            <Text typeface="body-1-m">
              <FormattedMessage
                id="vendors.no_vendors.new"
                defaultMessage="NEW!"
              />
            </Text>
          </StatusPill>
        </div>
        <div>
          <h4>
            <FormattedMessage
              id="vendors.no_vendors.do_more"
              defaultMessage="Do more than host? List it as a service."
            />
          </h4>
          <Text element="p" className="tw-mb-12">
            <FormattedMessage
              id="vendors.no_vendors.description"
              defaultMessage="Some hosts are also photographers, caterers, bartenders, or DJs. If
            that's you, create a separate service listing so guests planning
            events on Peerspace can find and book you at any venue, not just
            yours."
            />
          </Text>
          <Text element="p" className="tw-mb-24 tw-pb-4">
            <FormattedMessage
              id="vendors.no_vendors.description_alt"
              defaultMessage="Renting out equipment or physical items? Include those as add-ons to
            your space listing instead."
            />
          </Text>
          <div className="tw-flex tw-flex-col tw-gap-16">
            <Button
              className="tw-w-fit"
              href="https://hosts.trypeerspace.com/peerspace-vendor-onboarding"
            >
              <Text>
                <FormattedMessage
                  id="vendor.no_vendors.add_a_service"
                  defaultMessage="Add a service listing"
                />
              </Text>
            </Button>
            <Button
              className="tw-w-fit"
              variant="underline-m"
              href="https://hosts.trypeerspace.com/vendor-recommendations"
              onClick={handleReferClick}
            >
              <Text>
                <FormattedMessage
                  id="vendor.no_vendors.know_a_vendor"
                  defaultMessage="Know a great vendor? Refer them."
                />
              </Text>
            </Button>
          </div>
        </div>
      </div>
      <div className="tw-mt-32 md:tw-mt-0 md:tw-w-[50%] tw-relative">
        <img
          className="tw-hidden md:tw-block"
          src="https://img.peerspace.com/image/upload/v1786553252/Vendors_Desktop_1_ll5tsc.png"
          alt=""
        />
        <img
          className="tw-block md:tw-hidden"
          src="https://img.peerspace.com/image/upload/v1786553270/Vendors_Mobile_iyvy2w.png"
          alt=""
        />
      </div>
    </div>
  );
};

export default NoVendorsPanel;
